import { Rating } from '@/types';

import styles from './ProductRatingTag.module.scss';

type ProductRatingTagProps = {
  rating: Rating
}

const ProductRatingTag = ({ rating }: ProductRatingTagProps): React.JSX.Element => (
  <div className={styles.tag} data-test-id="note">
    {rating.name} | <span className={styles.value} data-test-id="value">{rating.value}</span>
  </div>
);

export default ProductRatingTag;
